const AOS_animation = require('../../../components/AOS-animation/AOS-animation.script');
const FV = require('../../../components/form-validation/form-validation.script');
const onboardingService = require("../../../../services/onboard")
const donorsService = require("../../../../services/donors")
const swal = require('sweetalert')

var files = [];

export async function load() {

    const personPictureFileInput = document.getElementById("personPicture");
    if (personPictureFileInput && personPictureFileInput != null && personPictureFileInput != '') {
        personPictureFileInput.addEventListener('change', (e) => {
            console.log('e', e)
            getFiles(e)
        })
    }

    try {
        await AOS_animation.start();


        const formEl = document
            .getElementById('etapa_2')
        await startForm(formEl)
        await FV
            .addMasksToView(formEl)
        // await FV.enableOrDisableFieldsByParams(formEl)

        await feelUserInfo(formEl)


        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}

async function feelUserInfo(formEL) {

    if (document.URL.split("/").length == 6) {
        var user = await donorsService.getProfile(document.URL.split("/")[5])
        console.log('user', user)

        await FV.setFormValues(formEL, user.data)

    }
}


function startForm(formEl) {
    formEl
        .addEventListener('submit', function (evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl)
        })
}


function generateFormData(bodyObject) {

    var formData = new FormData();

    files.forEach((file, i) => {
        if (files.length > 1) {
            formData.append(`photo[${i}]`, file, file.name);
        } else {
            formData.append(`photo`, file, file.name);
        }
    });

    Object.keys(bodyObject).forEach(key => {
        if (bodyObject[key] && bodyObject[key] != null && bodyObject[key] != '') {
            formData.append(key, bodyObject[key]);
        }
    });

    return formData;
}

async function sendForm(formEL) {
    let error422 = false;

    if (FV.thisFormIsValid(formEL)) {

        const button = document.getElementById('send-button');

        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        const value = await FV.getFormValues(formEL);
        const bodyObject = generateFormData(value);

        const type = document.getElementById('etapa_2').getAttribute('registerType');

        try {
            var response = await onboardingService.register(type, bodyObject)
            console.log('response', response)
            if (response.status != 200) {
                if (response.status === 422) {
                    swal("Informações já cadastradas!", "Por favor, verifique o e-mail e/ou CPF preenchidos", "error");
                    error422 = true;
                }

                response = await response.json()
                FV.validateFromServer(formEL, response.errors)
                if (button.classList.contains('loading')) {
                    button.classList.remove('loading');
                }
            } else {
                response = await response.json()
                console.log('response', response)
                window.barba.go(`/cadastro/etapa_3/${response.data.hash}`);
                if (button.classList.contains('loading')) {
                    button.classList.remove('loading');
                }
            }

        } catch (err) {
            if (button.classList.contains('loading')) {
                button.classList.remove('loading');
            }
            console.log("errXXX", err);

            if (!error422) {
                alert(err);
                return error422 = false;
            }
        }

    }
}


//  a function to get files from input file and show in view
function getFiles(e) {
    if (e) {
        Array.from(e.target.files).forEach((file) => {
            files.push(file)
        })

    }

    var htmlContainer = ''
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        htmlContainer = `
        <div class="fileListItem" item="${i}">
            <div class="info">
                <span class="name">${file.name}</span>
                <span class="size">${file.size} bytes</span>
            </div>
            <div class="action">
                <input type="button" id="deleteItem_${i}" item="${i}" />
            </div>
        </div>
        ${htmlContainer}`
    }

    document
        .getElementById('upload_list')
        .innerHTML = htmlContainer;

    Array.from(document.querySelectorAll("input[type='button']"))
        .forEach((item, i) => {
            item.addEventListener('click', (_e) => {
                files.splice(item.getAttribute("item"), 1)
                getFiles()
            })
        });
}
